import { Controller } from "@hotwired/stimulus";
import Chart from "chart.js/auto";

export default class extends Controller {
  static targets = ["canvas"];
  static values = {
    data: Object,
    options: Object,
  };

  connect() {
    this.renderChart();
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  renderChart() {
    if (!this.canvasTarget || !this.dataValue) {
      return;
    }

    const ctx = this.canvasTarget.getContext("2d");

    const defaultOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: window.innerWidth >= 1024 ? "right" : "bottom",
          labels: {
            padding: 20,
            usePointStyle: true,
            pointStyle: "circle",
            font: {
              size: 12,
            },
          },
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              const label = context.label || "";
              const value = context.parsed;
              return `${label}: ${value}%`;
            },
          },
        },
      },
      cutout: "60%",
      elements: {
        arc: {
          borderWidth: 2,
          borderColor: "#ffffff",
        },
      },
    };

    const options = { ...defaultOptions, ...this.optionsValue };

    this.chart = new Chart(ctx, {
      type: "doughnut",
      data: this.dataValue,
      options: options,
    });
  }
}
